var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 625 625",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 625,
    height: 625,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m589.58 208.44c0-46.052-37.388-83.44-83.44-83.44h-387.29c-46.052 0-83.44 37.388-83.44 83.44v166.88c-0 46.051 37.388 83.439 83.44 83.439h387.29c46.052 0 83.44-37.388 83.44-83.439v-166.88z",
    fill: "none",
    stroke: "#00ff85",
    strokeWidth: "31.49px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m62.112 147.29 250.39 191.82 249.97-192.21",
    fill: "none",
    stroke: "#00ff85",
    strokeWidth: "31.49px"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m550.66 445.89-188.21-145.19",
    fill: "none",
    stroke: "#00ff85",
    strokeWidth: "31.49px"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m73.716 445.49 187.69-144.79",
    fill: "none",
    stroke: "#00ff85",
    strokeWidth: "31.49px"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8cb5f72bcae70c942893b3a38597d3d4.svg";
export { ForwardRef as ReactComponent };